import { format } from 'date-fns'
import { useEffect, useState } from 'react'

import { useLogisticFilters } from 'hooks/useLogisticFilters'
import { useStores } from 'hooks/useStores'
import { logisticApi } from 'redux/services/logistic'
import { ProcessedLogisticObject } from 'redux/services/logistic/types'

import { AppLayout } from 'components/AppLayout'
import { AppLayoutTable } from 'components/AppLayoutTable'
import { AppLoader } from 'components/AppLoader'
import { AppPagination } from 'components/AppPagination'
import { AppTable } from 'components/AppTable'

import { LOGISTIC_STATUS_TEXT } from 'constants/logistic'
import { UserRole } from 'models/user'

import { ReactComponent as UserCircleAddIcon } from 'assets/images/svg/user_circle_add.svg'

import { Details } from './components/Details'
import { EmptyDetails } from './components/EmptyDetails'
import { Filters } from './components/Filters'
import { SelectCurier } from './components/SelectCurier'
import { Statistics } from './components/Statistics'

enum ModalState {
  None,
  Assign,
}

export const ProcessedPage = () => {
  const { userStore } = useStores()

  const { params, setParam, resetParams } = useLogisticFilters()
  const role = userStore.user?.role as UserRole
  const [modal, setModal] = useState<ModalState>(ModalState.None)
  const [selectedRowId, setSelectedRowId] =
    useState<ProcessedLogisticObject['id']>()
  const [fetch, fetchState] =
    logisticApi.useLazyGetProcessedLogisticCartsQuery()
  logisticApi.useGetProjectsQuery()

  // const { data: projects } = logisticApi.useGetProjectsQuery()

  // const project = projects?.find(p => p.id === data?.project.id)
  // logisticApi.useGetDeliverymensQuery()

  useEffect(() => {
    fetch(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.offset])

  const onSubmit = () => {
    fetch(params)
    setSelectedRowId(undefined)
  }
  const reset = () => {
    resetParams()
    fetch(params)
    setSelectedRowId(undefined)
  }
  const openModal = () => {
    setModal(ModalState.Assign)
    document.body.style.overflow = 'hidden'
  }

  const closeModal = () => {
    setModal(ModalState.None)
    document.body.style.overflow = 'auto'
  }

  const selectedRow = fetchState.data?.results.find(
    row => row.id === selectedRowId,
  )

  return (
    <>
      {[UserRole.Executor, UserRole.Administrator].includes(role) && (
        <AppLayout
          linksRight={[
            {
              title: 'Назначить',
              icon: <UserCircleAddIcon />,
              onClick: openModal,
            },
          ]}
        />
      )}
      <AppLayoutTable
        title="Обработанные заявки"
        header={<Filters onSubmit={onSubmit} reset={reset} />}
        statistics={<Statistics />}
        sidebarOpened={Boolean(selectedRow)}
        sidebar={
          selectedRow ? (
            <Details
              key={selectedRow.id}
              data={selectedRow}
              onClose={() => setSelectedRowId(undefined)}
            />
          ) : (
            <EmptyDetails />
          )
        }
      >
        {fetchState.isLoading && <AppLoader />}
        {fetchState.data && fetchState.isSuccess && (
          <>
            <AppTable
              loading={fetchState.isFetching}
              onClickRow={item => setSelectedRowId(item.id)}
              dataSource={fetchState.data.results}
              selected={{
                value: selectedRow?.id,
                key: 'id',
              }}
              headers={[
                {
                  data: 'ID Карты',
                  key: 'barcode',
                  width: 50,
                },
                {
                  data: 'Автор',
                  key: 'author',
                  render: (_, item) => item.author?.full_name,
                  width: 150,
                },
                {
                  data: 'Ф.И.О.',
                  key: 'client_full_name',
                  width: 150,
                },
                {
                  data: 'Консультант',
                  key: 'consultant',
                  render: (_, item) => item.consultant?.full_name,
                  width: 100,
                },
                {
                  data: 'Статус',
                  key: 'status',
                  render: (_, item) =>
                    item.status ? LOGISTIC_STATUS_TEXT[item.status] : '-',
                  width: 100,
                },
                {
                  data: 'Дата',
                  key: 'emboss_date',
                  render: (_, data) => {
                    if (data.emboss_date) {
                      return format(
                        new Date(data.emboss_date),
                        'yyyy-MM-dd HH:mm',
                      )
                    }
                  },
                  width: 100,
                },
                {
                  data: 'Стоимость доставки',
                  key: 'cost',
                },
                {
                  data: 'Оплачено',
                  key: 'card_type',
                  render: (_, item) => (item.is_paid ? 'да' : 'нет'),
                  width: 50,
                },
                {
                  data: 'Проект',
                  key: 'project',
                  render: (_, item) => item.project?.name,
                  width: 50,
                },
              ]}
            />

            <AppPagination
              forcePage={params.offset! / params.limit!}
              onPageChange={nextPage => {
                setParam('offset', String((nextPage - 1) * params.limit!))
              }}
              count={fetchState.data.count / params.limit!}
            />
          </>
        )}
      </AppLayoutTable>

      {modal === ModalState.Assign && <SelectCurier onClose={closeModal} />}
    </>
  )
}
